import { createContext } from 'react';

import { isMarketsPage, isTradePage } from 'helpers';

import { FavoritesContextValue } from './interface';

export const getMixpanelPageName = () => {
  let source;
  if (isMarketsPage()) {
    source = 'All Markets Page';
  } else if (isTradePage()) {
    source = 'Trade Page';
  } else {
    source = 'Others';
  }
  return source;
};

// Define FavoritesContext and give initial/default value.
export const FavoritesContext = createContext<FavoritesContextValue>({
  favoritesIds: [],
  toggleFavorite: () => {},
});
